import React, { useContext } from 'react'
import { makeStyles, Grid, useTranslation, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import type { QuoteStatus } from 'paintscout'
import classnames from 'classnames'
import CheckIcon from '@material-ui/icons/CheckCircleOutline'
import EditIcon from '@material-ui/icons/Edit'
import { QuoteContext } from '../../../context'

const useStyles = makeStyles<Theme, StatusStampProps>((theme) => ({
  root: {
    '&:hover': {
      cursor: 'pointer',
      '& $editIcon': {
        color: theme.palette.primary.main
      }
    }
  },
  color: {
    textTransform: 'capitalize',
    color: (props) => {
      return theme.palette.quote.status[props.status]
    }
  },
  checkIcon: {
    marginLeft: theme.spacing(1)
  },
  editIcon: {
    marginRight: theme.spacing(1),
    color: theme.paintscout.palette.brand.Neutral.P80,
    fontSize: '0.7rem',
    '@media print': {
      display: 'none'
    }
  }
}))
export interface StatusStampProps {
  status: QuoteStatus
}

function StatusStamp(props: StatusStampProps) {
  const { status } = props
  const classes = useStyles(props)
  const { isEditable, onEditInfo } = useContext(QuoteContext)
  const { __ } = useTranslation()

  const statusLabel = status.charAt(0).toUpperCase() + status.slice(1)
  const showCheck = status === 'accepted' || status === 'paid'
  return (
    <Grid className={classes.root} container alignItems="center" onClick={onEditInfo}>
      {isEditable && <EditIcon className={classes.editIcon} />}
      <Typography variant="overline" data-testid="quote-status" className={classes.color}>
        {__(statusLabel)}
      </Typography>
      {showCheck && <CheckIcon className={classnames(classes.color, classes.checkIcon)} />}
    </Grid>
  )
}

export default StatusStamp
